import React from 'react';
import Error from './ErrorPage';

const NotFoundPage: React.FC = () => {
    return (
        <Error code="404" message="Esta página não existe." />
    );
}

export default NotFoundPage;